const SANITY_VERSION = "3.99.0";
export {
  SANITY_VERSION
};
//# sourceMappingURL=version.mjs.map
